// modules/website/components/HeroComponent.tsx

import React from 'react';
import { HeroData } from '@/types';

interface Props {
  data: HeroData;
  settings: any;
}

export const HeroComponent: React.FC<Props> = ({ data, settings }) => {
  return (
    <div 
      className="relative min-h-[600px] flex items-center justify-center text-white"
      style={{
        backgroundColor: settings.backgroundColor || '#1e40af',
        backgroundImage: data.backgroundImage ? `url(${data.backgroundImage})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay */}
      {data.backgroundImage && (
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      )}
      
      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 drop-shadow-lg">
          {data.title}
        </h1>
        {data.subtitle && (
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            {data.subtitle}
          </p>
        )}
        
        {data.buttons && data.buttons.length > 0 && (
          <div className="flex flex-wrap gap-4 justify-center">
            {data.buttons.map((button, index) => (
              <a
                key={index}
                href={button.url}
                className={`px-8 py-4 rounded-lg font-semibold text-lg transition-all ${
                  button.variant === 'primary'
                    ? 'bg-white text-blue-900 hover:bg-gray-100 shadow-xl'
                    : button.variant === 'secondary'
                    ? 'bg-blue-600 text-white hover:bg-blue-700 shadow-xl'
                    : 'border-2 border-white text-white hover:bg-white hover:text-blue-900'
                }`}
              >
                {button.icon && <span className="mr-2">{button.icon}</span>}
                {button.text}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
